import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import productsSlice from './reducers/ProductSlice'

const persistConfig = {
    key: 'root',
    version: "1.1.0",
    storage,
}

const reducer = combineReducers({
    OEM: productsSlice,
})

const persistedReducer = persistReducer(persistConfig, reducer)

const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: false
    }),
})

export default store;

